/**
 * Created by olga on 22.09.2026
 */

const PinComponentView = function (component, unitView) {
    this.component = component;
    this.unitView = unitView;

    this.dimmed = [];
    this.targetAnimations = [];
};

PinComponentView.prototype.highlightDrag = function () {
    this.unHighlightDrag();

    Merge2.current.field.iterateUnits((x, y, unit) => {
        if (unit === this.component.unit) {
            return;
        }

        const unitView = unit.onGetView();
        if (!unitView) {
            return;
        }

        if (this.component.isPinnable(unit)) {
            this.createTargetAnimation(unitView);
            return;
        }

        if (!unit.findComponent(PinComponent) && !unit.isGrounded()) {
            unitView.setImageColor(PinComponentView.DIMMED_COLOR);
            this.dimmed.push(unit);
        }
    });
};

PinComponentView.prototype.createTargetAnimation = function (unitView) {
    const glow = new cleverapps.Spine(bundles.merge_animations.jsons.booster_target_glow_json);
    glow.setAlignment({
        x: { align: "center" },
        y: { align: "center" }
    });
    glow.setAnimation(0, "animation", true);
    unitView.addChild(glow, -1);

    this.targetAnimations.push(glow);
};

PinComponentView.prototype.unHighlightDrag = function () {
    const dimmed = this.dimmed;
    this.dimmed = [];

    dimmed.forEach((unit) => {
        const unitView = unit.onGetView();
        if (unitView) {
            unitView.restoreColor();
        }
    });

    const targetAnimations = this.targetAnimations;
    this.targetAnimations = [];

    targetAnimations.forEach((animation) => {
        animation.removeFromParent();
    });
};

PinComponentView.prototype.playClose = function () {
    const unitView = this.unitView;
    const sprite = unitView.sprite;

    unitView.stopAllActions();
    if (unitView.markLastAnimation) {
        unitView.markLastAnimation.setVisible(false);
    }
    unitView.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(unitView));

    if (sprite instanceof cleverapps.Spine && sprite.hasAnimation("close")) {
        sprite.setAnimation(0, "close", false);
        sprite.setCompleteListenerOnce(unitView.removeFromParent.bind(unitView));
    } else {
        unitView.removeFromParent();
    }
};

PinComponentView.prototype.clearAnimations = function () {
    this.unHighlightDrag();
};

PinComponentView.DIMMED_COLOR = new cc.Color(150, 150, 150, 255);
